import React from 'react';
import clsx from 'clsx';
import styles from './FeatureIntro.module.css';

interface FeatureIntroProps {
  eyebrow?: string;
  title?: string;
  description?: React.ReactNode;
  note?: React.ReactNode;
  actions?: React.ReactNode;
  className?: string;
}

const FeatureIntro: React.FC<FeatureIntroProps> = ({
  eyebrow,
  title,
  description,
  note,
  actions,
  className
}) => {
  if (!eyebrow && !title && !description && !note && !actions) {
    return null;
  }

  return (
    <section className={clsx(styles.root, className)}>
      {eyebrow ? <span className={styles.eyebrow}>{eyebrow}</span> : null}
      {title ? <h1 className={styles.title}>{title}</h1> : null}
      {description ? <p className={styles.description}>{description}</p> : null}
      {note ? <p className={styles.note}>{note}</p> : null}
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </section>
  );
};

export default FeatureIntro;
